import React, { useEffect, useContext } from 'react';
import Box from '../../components/single_component/Box';
import Card from '../../components/single_component/Card';
import Image from '../../components/single_component/Image';
import { Grid } from '@mui/material';
import Text from '../../components/single_component/Text';
import theme from '../../utils/Theme';
import Button from '../../components/single_component/Button';
import TableTop from '../../components/common_component/TableTop';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import DeleteConfirmModal from '../../components/common_component/DeleteConfirmModal';
import { toast } from 'react-toastify';
import LocationIcon from '../../assets/images/location.png';
import ProjectContext from '../../context/ProjectContext';
import Building from '../../assets/images/building.png';
import StringUtils from '../../utils/stringUtil';
import { ROUTES } from '../../types/routeObject';
import Loader from '../../components/single_component/Loader';

function ViewSpvContainer() {
  const navigate = useNavigate();

  const { getProjects, Projects, loading, softDeleteProject } = useContext(ProjectContext);

  const { spvId } = useParams();

  const location = useLocation();
  const [deleteModal, setDeleteModal] = React.useState<{ open: boolean; projectId: any }>({
    open: false,
    projectId: null,
  });
  const [deleteLoading, setDeleteLoading] = React.useState(false);

  const handleDeleteConfirm = async () => {
    setDeleteLoading(true);
    const response = await softDeleteProject(deleteModal.projectId, spvId);
    setDeleteLoading(false);
    setDeleteModal({ open: false, projectId: null });
    if (response.success) {
      toast.success(response.message);
    } else {
      toast.error(response.message);
    }
  };

  console.error('loading', loading);

  useEffect(() => {
    getProjects(spvId);
  }, []);

  // const handleBack = () => {
  //   const groupId = location?.state?.groupId;
  //   navigate(`${ROUTES.DEVELOPER_GROUP}/${groupId}`, {
  //     state: {
  //       groupId,
  //       groupName: location?.state?.groupName ?? '',
  //       promoterName: location?.state?.promoterName ?? '',
  //     },
  //   });
  // };

  const buttonComponent = () => {
    return (
      <>
        <Box style={{ display: 'flex', alignItems: 'center' }}>
          <Button
            extra={{
              variant: 'contained',
              color: 'primary',
            }}
            style={{ padding: '8px 24px' }}
            icons={<AddOutlinedIcon />}
            onClick={() =>
              navigate('/add-project', {
                state: {
                  spvId: location?.state?.spvId ?? '',
                  spvName: location?.state?.spvName ?? '',
                  groupName: location?.state?.groupName ?? 'N/A',
                },
              })
            }>
            <Text style={{ color: 'white', fontSize: 13 }}>Add Project</Text>
          </Button>
        </Box>
      </>
    );
  };

  return (
    <Box style={{ width: '85%', margin: 'auto' }}>
      <Box style={{ marginBottom: '12px' }}>
        <Button
          extra={{ variant: 'outlined' }}
          icons={<ArrowBackIcon fontSize="small" />}
          onClick={()=>navigate(-1)}
          style={{
            borderRadius: '20px',
            padding: '4px 16px',
            color: '#104960',
            borderColor: '#104960',
            textTransform: 'none',
          }}>
          <Text style={{ fontSize: 13, color: '#104960' }}>Back</Text>
        </Button>
      </Box>
      <Card>
        <TableTop
          extra={{
            label: StringUtils.capitalizeFirstLetter(
              location?.state?.spvName ?? ''
            ),
            description: `Here you can create and view projects under ${
              location?.state?.spvName ?? ''
            }`,
            Components: buttonComponent,
          }}
        />

        <Box style={{ width: '96%', margin: 'auto', marginBottom: 3 }}>
          {loading ? (
            <Loader />
          ) : (
            <Grid container spacing={2}>
              {Projects &&
                Projects.map((value: any, index: number) => {
                  return (
                    <Grid item xs={12} sm={6} md={4} lg={4} key={index}>
                      <Card style={{ paddingBottom: 1 }}>
                        <Image
                          src={value?.coverGallery?.imagePath ?? Building}
                          alt="Avatar"
                          style={{ width: '100%', height: 200 }}
                        />

                        <Box style={{ padding: 1 }}>
                          <Box
                            style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'flex-start',
                            }}>
                            <Text
                              style={{
                                fontSize: 14,
                                color: theme.palette.primary.main,
                                fontWeight: 600,
                              }}>
                              {StringUtils.capitalizeFirstLetter(
                                value.projectName
                              )}
                            </Text>
                            <DeleteOutlineIcon
                              sx={{ cursor: 'pointer', color: '#d32f2f', fontSize: 18 }}
                              onClick={() =>
                                setDeleteModal({ open: true, projectId: value.projectId })
                              }
                            />
                          </Box>
                          <Box style={{ marginTop: 1 }}>
                            {value.address == undefined ||
                            value.address == null ||
                            value.address == '' ? (
                              <Text
                                style={{
                                  fontSize: 12,
                                  color: theme.palette.primary.main,
                                }}>
                                N/A
                              </Text>
                            ) : (
                              <Box
                                style={{
                                  display: 'flex',
                                  justifyContent: 'flex-start',
                                  alignItems: 'center',
                                  gap: 0.5,
                                }}>
                                <Image
                                  src={LocationIcon}
                                  style={{
                                    width: 15,
                                    height: 15,
                                    objectFit: 'cover',
                                    alignSelf: 'flex-start',
                                  }}
                                />
                                <Text
                                  style={{
                                    fontSize: 12,
                                    color: theme.palette.primary.main,
                                  }}>
                                  {StringUtils.capitalizeFirstLetter(
                                    value.address
                                  )}
                                </Text>
                              </Box>
                            )}
                          </Box>

                          <Button
                            extra={{ variant: 'outlined' }}
                            onClick={() =>
                              navigate(
                                `${ROUTES.VIEW_PROJECT.replace(
                                  ':id',
                                  value.projectId
                                )}`,
                                {
                                  state: {
                                    spvId: location?.state?.spvId ?? '',
                                    projectName:
                                      StringUtils.capitalizeFirstLetter(
                                        value.projectName ?? ''
                                      ),
                                    spvName: location?.state?.spvName ?? '',
                                    groupName:
                                      location?.state?.groupName ?? 'N/A',
                                    groupId: location?.state?.groupId ?? '',
                                    executiveId:
                                      location?.state?.executiveId,
                                    executiveName:
                                      location?.state?.executiveName,
                                  },
                                }
                              )
                            }
                            style={{
                              marginTop: 2,
                              width: '100%',
                              padding: 1.5,
                            }}>
                            <Text style={{ fontSize: 12, fontWeight: 'bold' }}>
                              View Project
                            </Text>
                          </Button>
                        </Box>
                      </Card>
                    </Grid>
                  );
                })}
            </Grid>
          )}
        </Box>
      </Card>
      <DeleteConfirmModal
        open={deleteModal.open}
        onCancel={() => setDeleteModal({ open: false, projectId: null })}
        onConfirm={handleDeleteConfirm}
        loading={deleteLoading}
      />
    </Box>
  );
}

export default ViewSpvContainer;
